import { render, staticRenderFns } from "./DocumentAddOptionsPanel.vue?vue&type=template&id=0c3aa7d2&scoped=true&"
import script from "./DocumentAddOptionsPanel.vue?vue&type=script&lang=js&"
export * from "./DocumentAddOptionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAddOptionsPanel.vue?vue&type=style&index=0&id=0c3aa7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3aa7d2",
  null
  
)

export default component.exports